import { CoordinatorService } from "./coordinator.service"

export class Random$ {


    constructor(private coords: CoordinatorService) {

    }


    shuffleArray(array: any[]) {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1))
            var temp = array[i]
            array[i] = array[j]
            array[j] = temp
        }
    }

    randomSublist(items: any[], numberOfItems: number) {
        const ls: any[] = []
        const indexLs = Array.from(items.keys())
        this.shuffleArray(indexLs)
        indexLs.slice(0, numberOfItems).forEach(i =>
            ls.push(items[i])
        )
        return ls
    }

    getRandomInt(min: number, max: number) {
        min = Math.ceil(min)
        max = Math.floor(max)
        return Math.floor(Math.random() * (max - min) + min) //The maximum is exclusive and the minimum is inclusive
    }

}
